import { AxiosError } from "axios"
import { PropsWithChildren, useEffect } from "react"

import { httpClient } from "~/backend/axios"
import { useAuth } from "~/store/auth-context"

type Props = PropsWithChildren<object>

export function AxiosErrorHandler({ children }: Props) {
  const { logout } = useAuth()

  useEffect(() => {
    const responseInterceptor = httpClient.interceptors.response.use(
      (response) => response,
      async (error: AxiosError) => {
        if (error.response?.status === 401) {
          logout()
        }
        return Promise.reject(error)
      }
    )
    return () => {
      httpClient.interceptors.response.eject(responseInterceptor)
    }
  }, [logout])

  return <>{children}</>
}
